module.exports = __webpack_public_path__ + "static/media/s15.d0e784e0.webp";